import { render, staticRenderFns } from "./CS48Q.vue?vue&type=template&id=52e6ec6f&scoped=true&"
import script from "./CS48Q.vue?vue&type=script&lang=js&"
export * from "./CS48Q.vue?vue&type=script&lang=js&"
import style0 from "./CS48Q.vue?vue&type=style&index=0&id=52e6ec6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6ec6f",
  null
  
)

export default component.exports